export default __webpack_public_path__ + "static/media/logoPokemon.51f7c7fc.png";